import Splide from '@splidejs/splide';

import { order_campReviews, send_campReview } from "./util/review_scripts";
import { campReview_orderBy, vehicleTypeID } from "./util/type_defs";
import { reviewImg } from "./util/mustache_templates";
import mustache from 'mustache';
import { check_driveTimeStr_getNum, initializeTooltips, setCookie_base64, waitFor, initCookieChoice, getCookie, hide_tooltips, setCookie, getFeatureFlags, featureFlagKeys } from "./util/general_util";
import { filter_aANDa, filter_by_affiliates, filter_by_discounts, filter_by_price, filter_by_rvLW, filter_by_sites, getNumActiveFilters, setup_filter_listeners, update_aANDa_display } from './util/filter_campsites';
import { start_expandedCamp_log, stop_expandedCamp_log, addFilter_log } from './log';

// const $ = require('jquery');
import * as LDClient from 'launchdarkly-js-client-sdk';
import { filter_instantBook_camps } from './page-scripts/index_scripts';
import { disp_ALLcampData } from './util/general_ui_construction';
import { event } from 'jquery';
declare global {
	interface Window {
		review_images:File[];
		featureFlags:Record<string,LDClient.LDFlagValue>;
		webAuth:any

		rvRental_sDate_pickr:any;
        rvRental_eDate_pickr:any;

		parkId:any;
		instantBoook_Date_pickr:any;
		availability:string[];
		vehicle:{
			type:vehicleTypeID|"";
			length:number;
			d_slide:boolean;
			p_slide:boolean;
			r_slide:boolean;
		};
		guests: {
			adults:number;
			children:number;
			infants:number;
			pets:number;
		};
		spotId:number;
	}
};

const header = document.querySelector('header.agNavbar');
if (header) {
	const resizeObserver = new ResizeObserver(entries => {
	for (let entry of entries) {
		const headerHeight = (entry.target as HTMLElement).offsetHeight.toString();
		document.querySelectorAll(".bodyStyling").forEach(function(el:HTMLElement,key,parent) {
			el.style.paddingTop = headerHeight + 'px';
		});
		if (window.location.pathname == "/tripPlanner" || window.location.pathname == "/tripPlanner") {
			const tp_wrap = document.getElementById("tripPlannerPageWrap");
			if (tp_wrap) {
				tp_wrap.style.maxHeight = `calc(100vh - ${headerHeight}px)`;
			}
		};
	};
	});
	resizeObserver.observe(header);
};

window.addEventListener("DOMContentLoaded", () => {
	if (window.location.search.includes("showTrialStart=true")) {
		$(".modal").modal("hide");
		$("#memberCardedTrialModal").modal("show");
		if (window.location.search.includes("affiliateID")) {
			let affiliateID:string = (new URLSearchParams(window.location.search)).get("affiliateID");
			$("#memberCardedTrialModal").find("[name='affiliateID']").val(affiliateID);
		}
		window.history.replaceState({},document.title,window.location.pathname);
	};

	const vidWrapper = document.getElementById("agBooyahVid");
	if (vidWrapper != undefined) {
		vidWrapper.innerHTML = '<iframe style="height: 100%; border-radius: 2rem; min-height:400px;" src="' + vidWrapper.getAttribute('videoURL') + '" title="AdventureGenie RV Trip Planner Highlight Video" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share")></iframe>'
	}

	$(`.agNavbar a[href="${window.location.pathname}"]`).addClass("active");
});

// $(document).on("click", function(event) {
// 	console.log("click event:",'target: ', JSON.stringify(event.target), "\ntarget id:",(event.target as unknown as HTMLElement).id, "\ntarget class:", (event.target as unknown as HTMLElement).className, "\ntarget name:", (event.target as unknown as HTMLElement).getAttribute('name'));
// });
// $(document).on("touchstart", function(event) {
// 	console.log("touch event:", 'target: ', JSON.stringify(event.target), "\ntarget id:",(event.target as unknown as HTMLElement).id, "\ntarget class:", (event.target as unknown as HTMLElement).className, "\ntarget name:", (event.target as unknown as HTMLElement).getAttribute('name'));
// });

function force_focus(el:any) {
  $(el).focus();
}
$(document).on("focus", ".form-control", function(){
  $(this).on("blur", force_focus);
  setTimeout(()=> {
    $(this).off("blur")
  }, 100);
});

if (window.location.pathname === "/login") {
	console.log(document.documentElement.outerHTML);
};


let prevLoginCookie = getCookie("loggedIn");
function pollLoginCookie() {
	const val = getCookie("loggedIn");
	if (val !== prevLoginCookie) {
		window.location.reload();
	};
	prevLoginCookie = val;
};
setInterval(pollLoginCookie, 5000);

initializeTooltips();

document.querySelectorAll('.image-popup').forEach((element) => {
  element.addEventListener('click', (event) => {
    event.preventDefault();

    const imageUrl = (event.target as HTMLImageElement).src;

    $('#myModal .modal-body').html(`<img src="${imageUrl}" alt="Image" />`);
		$('#myModal').modal('show');

  });
});

$(document).on("click", "[data-bs-target='#memberCardedTrialModal'][toggleTrial_monthly]", function() {
	$("#memberCardedTrialModal").find("#monthly-trial").prop("checked",true);
});
$(document).on("click", "[data-bs-target='#memberCardedTrialModal'][toggleTrial_annual]", function() {
	$("#memberCardedTrialModal").find("#annual-trial").prop("checked",true);
});


$(document).on("click", "#acceptAllCookie", function(){
	setCookie_base64("cookieChoice","2","",1000000);
	initCookieChoice();
});
// $(document).on("click","#onlyRequiredCookie", function() {
// 	setCookie_base64("cookieChoice","1","",1000000);
// 	initCookieChoice();
// });

import'./index_page';
import'./camps_page';
import'./signIn_signUp_init';
import'./favorites';
import'./settings_page';
import'./reauthenticatePage';
import'./myTrips';
import'./agTrips';
import'./genieTrip_page';
import'./util/ag_js';
import'./campInfoUpdate_page'
import'./util/infocards';
import'./loginsignup_page';
import'./ambass_form';
import'./instantBook_integration';
import'./reservationsPage';
import "./wordpressIntegration";
import { uploadCampPhotos } from './util/upload-image';

console.log("    __________________________________\n    |             ,___,               \\\n    |  ,_____,    |   |      ____ ____/\n    |  |     |    |   |      |   \\\\\n    |  |_____|    |   |      |____\\\\_____\n====|             |___|                  \\=======\n    |  o     ___                   ___   |\n    |_______/(0)\\_________________/(0)\\__|\n     ----        ----        ----        ----\n\n\n=================================================\n");

$(document).on("shown.bs.modal",".modal",function(){
	$(".agNavbar #collNav.collapse").collapse("hide");
	hide_tooltips();
})

$(document).on("click", "#cgCardInstantBookButton", function(){
	$("#cgCardTablistContainer > ul > li:not(#instantBookTab)").addClass("d-none");
	$('html, body').animate({scrollTop: '0px'}, 300);
	$("#instantBookTab").removeClass("d-none");
	document.getElementById('openReserveTab').click();
});

$(document).on("click", "#closeReserveTab", async function(){
	$("#cgCardTablistContainer > ul > li:not(#instantBookTab)").removeClass("d-none");
	$("#instantBookTab").addClass("d-none");
	await waitFor(.01);
	document.getElementById('mainInfoTab').click();
});


if (!(window.location.pathname.includes("/tripPlanner") || window.location.pathname.includes("/tripPlanner"))) {
	$(document).on("click", ".aANDaRESETbuttonActivity", function(){

		$(".activityToggleButton").each(function(){
			if($(this).hasClass("active")){
				$(this).removeClass("active");
				filter_aANDa("activity", $(this).attr("id"), "rem");
			}
		});
		update_aANDa_display();

	});

	//CHECKS to see if the user clicked "reset" on amenities or activities. This will clear all active selected amenities/activities.
	$(document).on("click", ".aANDaRESETbuttonAmenity", function(){
		$(".amenityToggleButton").each(function(){
			if($(this).hasClass("active")){
				$(this).removeClass("active");
				filter_aANDa("amenity", $(this).attr("id"), "rem");
			}
		});


		update_aANDa_display();

	});

	//RESET BUTTONS FOR FILTERS
	$(document).on("click", ".priceReset", function(){
		$("#price_min").val("");
		$("#price_max").val("");
		filter_by_price();
		update_aANDa_display();
	});

	$(document).on("click", ".rvLreset", function(){
		$("#rvL_min").val("");
		$("#rvL_max").val("");
		let lenMin:number = parseInt($("#rvL_min").val().toString());
		let lenMax:number = parseInt($("#rvL_max").val().toString());
		let widMin:number = parseInt($("#rvW_min").val().toString());
		let widMax:number = parseInt($("#rvW_max").val().toString());
		filter_by_rvLW({len_min:lenMin,len_max:lenMax,wid_min:widMin,wid_max:widMax});
		update_aANDa_display();
	});
	$(document).on("click", ".rvWreset", function(){
		$("#rvW_min").val("");
		$("#rvW_max").val("");
		let lenMin:number = parseInt($("#rvL_min").val().toString());
		let lenMax:number = parseInt($("#rvL_max").val().toString());
		let widMin:number = parseInt($("#rvW_min").val().toString());
		let widMax:number = parseInt($("#rvW_max").val().toString());
		filter_by_rvLW({len_min:lenMin,len_max:lenMax,wid_min:widMin,wid_max:widMax});
	});

	$(document).on("click", ".amenityToggleButton", function(event: { target: { closest: (arg0: string) => HTMLElement; }; }){
		let clickedButton:HTMLElement = event?.target.closest("button");
		filter_aANDa("amenity",  $(this).attr("id"), $(this).hasClass("active") ? "rem":"add");
    clickedButton.classList.toggle("active");
	});

	$(document).on("click", ".activityToggleButton", function(event: { target: { closest: (arg0: string) => HTMLElement; }; }) {
		let clickedButton:HTMLElement = event?.target.closest("button");
		filter_aANDa("activity", $(this).attr("id"), $(this).hasClass("active") ? "rem":"add");
		clickedButton.classList.toggle("active");
	});

	let typingTimer: ReturnType<typeof setTimeout>;
	const doneTypingInterval = 250;
	//Sites Filtering
	$(document).on("input", "#sites_min", function(){
			if($(this).val() === '') filter_by_sites();
			clearTimeout(typingTimer);
			typingTimer = setTimeout(function(){
				let inputMin:number = parseInt($(this).val().toString());
				let inputMax:number = parseInt($("#sites_max").val().toString());
				if(inputMin > 0) filter_by_sites();
			}.bind(this), doneTypingInterval);
		}).on("blur", "#sites_min", function(){
			let inputMin:number = parseInt($(this).val().toString());
			let inputMax:number = parseInt($("#sites_max").val().toString());
			filter_by_sites();
			update_aANDa_display();
		});

		$(document).on("input", "#sites_max", function(){
			if($(this).val() === '') filter_by_sites();
			clearTimeout(typingTimer);
			typingTimer = setTimeout(function(){
				let inputMin:number = parseInt($("#sites_min").val().toString());
				let inputMax:number = parseInt($(this).val().toString());
				if(inputMin > 0) filter_by_sites();
			}.bind(this), doneTypingInterval);
		}).on("blur", "#sites_max", function(){
			let inputMin:number = parseInt($("#sites_min").val().toString());
			let inputMax:number = parseInt($(this).val().toString());
			filter_by_sites();
			update_aANDa_display();
		});

		//Price Filtering
		$(document).on("input", "#price_min", function(){
				if ($("#price_min").val() === '') {
						filter_by_price({val_min:parseInt($("#price_min").val().toString()),val_max:parseInt($("#price_max").val().toString())});
				}
				clearTimeout(typingTimer);
				typingTimer = setTimeout(function(){
					let inputMin:number = parseInt($("#price_min").val().toString());
					let inputMax:number = parseInt($("#price_max").val().toString());
					if (inputMin > 0) {
							filter_by_price({val_min:inputMin,val_max:inputMax});
					}
				}, doneTypingInterval);
		}).on("blur", "#price_min", function(){
				let inputMin:number = parseInt($("#price_min").val().toString());
				let inputMax:number = parseInt($("#price_max").val().toString());
				filter_by_price({val_min:inputMin,val_max:inputMax});
				update_aANDa_display();
		});

		$(document).on("input", "#price_max", function(){
			// if (window.location.pathname === "/campgrounds") return;

			if ($("#price_max").val() === '') {
					filter_by_price({val_min:parseInt($("#price_min").val().toString()),val_max:parseInt($("#price_max").val().toString())});
			}
			clearTimeout(typingTimer);
			typingTimer = setTimeout(function(){
				let inputMin:number = parseInt($("#price_min").val().toString());

				let inputMax:number = parseInt($("#price_max").val().toString());
				if (inputMin > 0) {
						filter_by_price({val_min:inputMin,val_max:inputMax});
						$("#price_min").attr("current_value",inputMax)
				}
			}, doneTypingInterval);
		}).on("blur", "#price_max", function(){

			let inputMax:number = parseInt($("#price_max").val().toString());
			let inputMin:number = parseInt($("#price_min").val().toString());
			filter_by_price({val_min:inputMin,val_max:inputMax});
			update_aANDa_display();

		});




		//RVLen/Wid Filtering filter_by_rvLW
		$(document).on("input", "#rvL_min, #rvL_max, #rvW_min, #rvW_max", function(){
				clearTimeout(typingTimer);
				typingTimer = setTimeout(function(){

					let lenMin:number = parseInt($("#rvL_min").val().toString());
					let lenMax:number = parseInt($("#rvL_max").val().toString());
					let widMin:number = parseInt($("#rvW_min").val().toString());
					let widMax:number = parseInt($("#rvW_max").val().toString());
					filter_by_rvLW({len_min:lenMin,len_max:lenMax,wid_min:widMin,wid_max:widMax});
					update_aANDa_display();

				}, doneTypingInterval);
		}).on("blur", "#rvL_min, #rvL_max, #rvW_min, #rvW_max", function(){

			let lenMin:number = parseInt($("#rvL_min").val().toString());
			let lenMax:number = parseInt($("#rvL_max").val().toString());
			let widMin:number = parseInt($("#rvW_min").val().toString());
			let widMax:number = parseInt($("#rvW_max").val().toString());
			filter_by_rvLW({len_min:lenMin,len_max:lenMax,wid_min:widMin,wid_max:widMax});
			update_aANDa_display();

		});

		//
		//END FILTERING
		//

		$(document).on("click", "#filterSmallCamp", function(){
			filter_by_sites({but:"small", active:!$("#filterSmallCamp").hasClass("active")});
		});
		$(document).on("click", "#filterMediumCamp", function(){
			filter_by_sites({but:"medium", active:!$("#filterMediumCamp").hasClass("active")});
		});
		$(document).on("click", "#filterLargeCamp", function(){
			filter_by_sites({but:"large", active:!$("#filterLargeCamp").hasClass("active")});
		});

		$(document).on("click","#instantBook", function() {
			//need to negate this since this on click is hitting before the active class is being applied
			if ($(this).hasClass('active')) {
				$(this).removeClass('active');
			} else {
				addFilter_log("s2nCS", "")
				$(this).addClass('active');
			};

			filter_instantBook_camps($(this).hasClass('active'));
		});

};

//Deal with discount and affiliate filtering
//HARDCODED :O, make sure the arrays below match with RVtrippy_partials/filters/dANDaFILTERS.pug, main.ts, and index_scipts.ts
let discounts: string[] = ["Military Veteran", "Good Sam Club", "Senior Citizen", "AAA Member"];
//Iterate through and make the array match the ID's in pug
discounts = discounts.map((discount) => {
  return discount.toLowerCase().replace(/\s+/g, '_');
});
let affiliates: string[] = ["KOA", "Sun Outdoors", "COE", "NPS", "NFA", "State Park"];
//Iterate through and make the array match the ID's in pug
affiliates = affiliates.map((affiliate) => {
  return affiliate.toLowerCase().replace(/\s+/g, '_');
});

$(document).ready( async function() {
	const url_search_params = new URLSearchParams(window.location.search);
	if (url_search_params.get("startCardedTrial") == "true") {
		$("#memberCardedTrialModal").modal("show");
	} else if (url_search_params.get("signUp") == "t" && getCookie("p-su-o").length == 0) {
		setCookie("p-su-o", 't', '', 10e100);

		if (window.featureFlags == undefined) {
			window.featureFlags = await getFeatureFlags(featureFlagKeys);
		};
		if (window.featureFlags["post-signup-offer"] == "checkout") {
			$("#postSignupModal_toCheckout").modal("show");
		} else {
			$("#postSignupModal").modal("show");
		}

		$("#postSignupModal_toCheckout,#postSignupModal").on("hide.bs.modal", () => {
			setTimeout(() => {
				wisepops("event", "new-tp-video");
			}, 2000);
		});
	};

	$('[modal-u-children="true"]').find('*').attr('modaluchild', 'true');

  $('.image-popup-link').click(function(event: { preventDefault: () => void; }) {
    event.preventDefault();
    $('#imageModalUnique').css('display', 'flex');
    $('.modal-image-unique').attr('src', $(this).attr('link'));
  });

  $('.close-button-unique').click(function() {
    $('#imageModalUnique').css('display', 'none');
  });

  $('.share-button-unique').click(function() {
    // Add your share functionality here
  });

	$('.modal-unique').click(function(event: { target: any; }) {
		if (!$(event.target).attr('modaluchild') && !$(event.target).attr('modal-u-children')) {
			$(this).css('display', 'none');
		}
	});



  //initalize splide for browse camps pages
  var elms = document.getElementsByClassName( 'splideStates' );
	for ( var i = 0; i < elms.length; i++ ) {
		new Splide( elms[i] as HTMLElement ).mount();
	};
	if (! (window.location.pathname.includes("/tripPlanner") || window.location.pathname.includes("/tripPlanner"))) {
		//Set up listeners for every discount/affiliate button
		discounts.forEach((id) => {
			$("#" + id).click(function(this:HTMLElement){
					filter_by_discounts("#" + id, discounts, !$(this).hasClass("active"));
				});
		});

		affiliates.forEach((id) => {
			$("#" + id).click(function(this:HTMLElement){
					filter_by_affiliates("#" + id, affiliates, !$(this).hasClass("active"));
				});
		});
	};
	//Also work on image seo.
	var choices = [
		"Discover Unforgettable Camping Sites with AdventureGenie - AI Trip Planning",
		"Your Guide to the Best RV Adventures in the US - AdventureGenie - AI Trip Planning",
		"Explore Top-Rated Campgrounds with AdventureGenie - AI Trip Planning",
		"Plan Your Perfect Camping Trip with AdventureGenie - AI Trip Planning",
		"Find Your Next Adventure with AdventureGenie - AI Trip Planning",
		"Navigate the Great Outdoors with AdventureGenie - AI Trip Planning",
		"Experience the Joy of Camping with AdventureGenie - AI Trip Planning",
		"Your Companion for Memorable Camping Adventures - AdventureGenie - AI Trip Planning",
		"Unleash Your Wanderlust with AdventureGenie - AI Trip Planning",
		"Your Gateway to Exciting RV Trips - AdventureGenie - AI Trip Planning",
		"Plan, Explore, and Enjoy with AdventureGenie - AI Trip Planning",
		"Your Ultimate Camping Trip Planner - AdventureGenie - AI Trip Planning",
		"Experience the Best of Nature with AdventureGenie - AI Trip Planning",
		"Your Personal Guide to the Best Campgrounds - AdventureGenie - AI Trip Planning",
		"Discover the Joy of Outdoor Adventures with AdventureGenie - AI Trip Planning",
		"Your Trusted Partner for Camping Trips - AdventureGenie - AI Trip Planning",
		"Explore, Dream, and Discover with AdventureGenie - AI Trip Planning",
		"Your Passport to Amazing Camping Adventures - AdventureGenie - AI Trip Planning",
		"Find Your Perfect Camping Spot with AdventureGenie - AI Trip Planning",
		"Your Adventure Starts Here with AdventureGenie - AI Trip Planning",
		"Experience Unforgettable RV Trips with AdventureGenie - AI Trip Planning",
		"Your Guide to Memorable Outdoor Adventures - AdventureGenie - AI Trip Planning",
		"Plan Your Dream Camping Trip with AdventureGenie - AI Trip Planning",
		"Your Companion for Exciting RV Journeys - AdventureGenie - AI Trip Planning",
		"Discover the Best Camping Sites with AdventureGenie - AI Trip Planning",
		"Your Personal Assistant for Trip Planning - AdventureGenie - AI Trip Planning",
		"Experience the Great Outdoors with AdventureGenie - AI Trip Planning",
		"Your Guide to the Best Camping Adventures - AdventureGenie - AI Trip Planning",
		"Plan, Discover, and Enjoy with AdventureGenie - AI Trip Planning",
		"Your Gateway to Memorable Camping Experiences - AdventureGenie - AI Trip Planning",
		"Explore the Best of Nature with AdventureGenie - AI Trip Planning",
		"Your Trusted Guide for RV Adventures - AdventureGenie - AI Trip Planning",
		"Discover, Explore, and Enjoy with AdventureGenie - AI Trip Planning",
		"Your Passport to Exciting Camping Trips - AdventureGenie - AI Trip Planning",
		"Experience the Joy of RV Trips with AdventureGenie - AI Trip Planning",
		"Your Guide to Exciting Outdoor Adventures - AdventureGenie - AI Trip Planning",
		"Plan Your Perfect Outdoor Adventure with AdventureGenie - AI Trip Planning",
		"Your Companion for Memorable Camping Trips - AdventureGenie - AI Trip Planning",
		"Discover the Best RV Sites with AdventureGenie - AI Trip Planning",
		"Your Personal Assistant for Camping Adventures - AdventureGenie - AI Trip Planning",
		"Experience the Great American Outdoors with AdventureGenie - AI Trip Planning",
		"Your Guide to Unforgettable RV Journeys - AdventureGenie - AI Trip Planning",
		"Experience the Best Camping Trips with AdventureGenie - AI Trip Planning",
		"Your Personal Assistant for Unforgettable RV Adventures - AdventureGenie - AI Trip Planning",
		"Explore, Dream, and Discover the Great Outdoors with AdventureGenie - AI Trip Planning",
		"Your Passport to the Best Camping Experiences - AdventureGenie - AI Trip Planning",
		"Find Your Perfect RV Adventure with AdventureGenie - AI Trip Planning",
		"Your Adventure Companion for Memorable Camping Trips - AdventureGenie - AI Trip Planning"
	];

	var randomAltText = choices[Math.floor(Math.random() * choices.length)];

	$("#img_alt_wrapper").attr("alt", randomAltText);
	$("#img_alt_wrapper2").attr("alt", randomAltText);
	$("#img_alt_wrapper3").attr("alt", randomAltText);
});

if (!(window.location.pathname.includes("/tripPlanner") || window.location.pathname.includes("/tripPlanner"))) {
	setup_filter_listeners();
};



//Generic toggle for toggle button class active effect
$(document).on("click", ".ToggleButton", function(event: { target: { closest: (arg0: string) => HTMLElement; }; }){
	let clickedButton:HTMLElement = event?.target.closest("button");
	clickedButton.classList.toggle("active");

	if (window.location.pathname === "/tripPlanner" || window.location.pathname === "/tripPlanner") {
		$("a[href='#stayCampgroundFilters']").html("Campground Filters (" + getNumActiveFilters().toString() + " selected) <i class='ai-chevron-up'>");
	};
});

$(".searchBar-iconGroup").on("click",function(){
	$(this).find("input").trigger("focus");
});

$(document).on("change", "#drive-time", function() {
	let driveTime:number;
	let driveTime_str:string;

	driveTime_str = $(this).val().toString();

	if ( (driveTime = check_driveTimeStr_getNum(driveTime_str)) < 180) {
		$(this).val("03:00");
	};
});

$(document).on("change", "#drive-dist", function() {
	let driveDist:number|string = $(this).val() as number|string;
	if (typeof(driveDist) == "string") {
		driveDist = parseInt(driveDist);
	};
	if (Number.isNaN(driveDist)) {
		$(this).val(300);
	} else if (driveDist < 150) {
		$(this).val(150);
	};
});

$(document).on("keydown", "#review-text", function() {
	if ($("#reviewText-feedback").length) ($("#reviewText-feedback")[0] as HTMLInputElement).setCustomValidity("");
});

//Added this to try and get reviews to work on fullpage camp page
$(document).on("submit", "#submitCampReview", function(event: { preventDefault: () => void; }){
	event.preventDefault();
	const submitElement: HTMLElement | null = this;
	let reviewTextFeedbackEl:HTMLInputElement = $("#reviewText-feedback")[0] as HTMLInputElement;
	if (submitElement instanceof HTMLFormElement) {
		let valid: boolean = submitElement.checkValidity();
		submitElement.reportValidity();
		if (valid) {
			if (!$("input[name='rating']:checked").length) {
				($("reviewRating-feedback")[0] as HTMLInputElement).setCustomValidity("Please Choose Rating");
				return;
			}
			let rating:number = $("input[name='rating']:checked").val() as number;
			let text:string = $("#review-text").html().toString();
			if (!text.length || text === "<br>") {
				reviewTextFeedbackEl.setCustomValidity("Please Include Text");
				return;
			};
			send_campReview(text, rating, parseInt($("#reviewCardCampID").html()),window.review_images);
			window.review_images = [];
		};
	};
});
$("#campReviewSort").on("change", (event: any) => {
	switch($("#campReviewSort").find(":selected").html()) {
		case "Oldest":
			order_campReviews(campReview_orderBy.Oldest);
			break;
		case "Newest":
			order_campReviews(campReview_orderBy.Newest);
			break;
		case "High rating":
			order_campReviews(campReview_orderBy.RatingHigh);
			break;
		case "Low rating":
			order_campReviews(campReview_orderBy.RatingLow);
			break;
		default:
			break;
	};
});

window.review_images = [];

$(document).on("click", "#newReview-addImg",function(){$("#newReview-addImg-Input").trigger("click")});
$("#newReview-addImg-Input").on("change", (event) => {
	let selectedFiles:FileList = (event.target as HTMLInputElement).files as FileList;
	window.review_images = Array.from(window.review_images);
	window.review_images.push(...(Array.from(selectedFiles)));
	$("#newReview-addImg-err").html("");
	for (let j:number=0; j < selectedFiles.length; j++) {
		let fileSize_MB = selectedFiles[j].size / (1024 * 1024);
		let fileName:string = selectedFiles[j].name;
		if (fileSize_MB > 30) {
			$("#newReview-addImg-err").append($(`<h6 class="text-danger">File ${fileName} too large (>3MB)</h6>`))
		} else {
			let reader:FileReader = new FileReader();
			reader.onload = (e) => {
				$("#new-review-image-wrap").append(mustache.render(reviewImg,{img_src:e.target.result}));
			};
			reader.readAsDataURL(selectedFiles[j]);
		};
	};
});

$(document).on("click", ".input-group span.input-group-text", function() {
	if ($(this).find(".ai-search,.ai-search2").length) {
		$(this).closest(".input-group").find("input").trigger("focus");
	};
});

$(document).on("click", "#mobileCampTab, #mobileGTTab", async function(){
	if(window.location.pathname == "" || window.location.pathname == "/" || window.location.pathname == "#camps" || window.location.pathname == "#trips" || window.location.pathname == "#tp" ){
		await waitFor(.1);
		window.location.reload();
	}
});

$(document).on("click", ".campCardMobileHeader", function(event: { target: { matches: (arg0: string) => any; }; }) {
	if (event.target.matches(".favorite-camp-icon") || event.target.matches(".favorite-camp-icon-favorited")) {
		return;
	}
	$(this).parent().find(".camp-card-body").click();
});

$(document).on("click", ".camp-card-body:not([camp-url])", function(event: { target: { matches: (arg0: string) => any; }; }) {

	if ($(event.target).closest(".unfavorite-trigger").length > 0 || event.target.matches(".unfavorite-trigger") || $(event.target).closest(".favorite-trigger").length > 0 || event.target.matches(".favorite-trigger") || $(event.target).closest("[remove-stay]").length > 0 || event.target.matches("[remove-stay]") || $(event.target).closest("[stay-date-display]").length > 0 || event.target.matches("[stay-date-display]") || $(event.target).closest("[stay-date-selector]").length > 0 || event.target.matches("[stay-date-selector]") || event.target.matches("[tieredFeature]") || event.target.matches("[tieredFeature] > .ai-plus-square") || event.target.matches(".favorite-camp-icon") || event.target.matches(".favorite-camp-icon-favorited") || event.target.matches(".ai-external-link") || event.target.matches("[add-stay-to-stop] > .ai-plus-square") || event.target.matches("[add-stay-to-stop] > h6") || event.target.matches("[add-stay-to-stop]") || event.target.matches("[removestaybutton]") || event.target.matches("[removestaybutton] > .ai-trash-2") || event.target.matches("[addStayButton] > .ai-git-pull-request") || event.target.matches("[remove-stay]") || event.target.matches("[suggested-stop-feedback]")) {
		return;
	} else {

		//This should open a new tab with the value of the href
		$("#modalCampPageLink").attr("href", $(this).attr("href"));

		let last_campID:number = parseInt($("#reviewCardCampID").html());
		let camp_id: number = parseInt($(this).attr('id'));

		const legIndex:number = parseInt($(this).attr("leg"));
		const stopIndex:number = parseInt($(this).attr("stop"));

		if (last_campID != camp_id) {
			//clear any in-progress reviews for other camps
			$("#review-text").html("");
			$("input[name='rating']:checked").prop("checked",false);

			$("#new-review-image-wrap").html("");
			//set it to an empty list
			// ($('#newReview-addImg-Input')[0] as HTMLInputElement).files = new DataTransfer().files;
			window.review_images = [];
		};

		$("#reviewCardCampID").html(camp_id.toString());

		start_expandedCamp_log(camp_id);

		disp_ALLcampData(camp_id,legIndex,stopIndex,this);
	};
});

$(document).on("hidden.bs.modal", "#campExpandedModal", function(){
	stop_expandedCamp_log();
});

$(document).on("shown.bs.modal","#errorModal", () => {
	$("#errMsgDisp").html("");
})

$(document).on("change", "#campReviewSort", function(event: any) {
	switch($("#campReviewSort").find(":selected").html()) {
		case "Oldest":
			order_campReviews(campReview_orderBy.Oldest);
			break;
		case "Newest":
			order_campReviews(campReview_orderBy.Newest);
			break;
		case "High rating":
			order_campReviews(campReview_orderBy.RatingHigh);
			break;
		case "Low rating":
			order_campReviews(campReview_orderBy.RatingLow);
			break;
		default:
			break;
	};
});

$(document).on("animationend", ".highlight-border", function() {
	$(this).removeClass("highlight-border");
});

$("#upload_trip_spreadsheet").on("change", function(event){
	event.preventDefault();
	$("#errMsg").html("");
	$("#upload_spreadsheet_loading").removeClass("d-none");
	let fileInput:HTMLInputElement = this as HTMLInputElement;
	let file:File|null = fileInput.files ? fileInput.files[0] : null;
	if (file != null) {
		const formData = new FormData();
		formData.append('file', file);
		$.ajax({
			type: "post",
			url: "/importTrip",
			data: formData,
			processData: false,
			contentType: false,
			success: (data) => {
				window.location = data.redirectUrl
			},
			error: (xhr, errStr, exc)=>{
				console.log(errStr);
				$("#upload_spreadsheet_loading").addClass("d-none");
				$("#errMsg").html("Could not load trip from spreadsheet");
			}
		})
	} else {
		$("#errMsg").html("Please upload a spreadsheet");
	}
});

$(document).on("input", ".data-form-input", function() {

  //Find the form and submit button for this input element
  let formEl:JQuery<HTMLElement> = $(this).parent().closest("form");
  let submitBtn:JQuery<HTMLElement> = formEl.find("button[type='submit']");
  let allSame:boolean = true;
  //Check if anything has changed
  $(".data-form-input").each(function(this){
    //need to handle check boxes differently than text/number inputs
    if ($(this).prop("type") == "checkbox") {
      //User said this campground has an amenity that our DB says it does not
      if ($(this).prop("checked") && $(this).attr("current_value").toString() == "0") {

        submitBtn.prop("disabled",false);
        allSame = false;
        return false;
      //User said this campground does not have an amenity that our DB says it does
      } else if ((!($(this).prop("checked"))) && $(this).attr("current_value").toString() == "1") {
        submitBtn.prop("disabled",false);
        allSame = false;
        return false;
      };
    //ensure valid format of date inputs
    } else if (($(this).attr("id") == "open_date") || ($(this).attr("id") == "close_date")) {
      const regex = /^\d{2}\/\d{2}\/\d{4}$/;
      submitBtn.prop("disabled",!(regex.test($(this).val().toString())));
    //ensure valid format of phone number input
    } else if (($(this).attr("id") === "info_phone") || ($(this).attr("id") === "reserve_phone")){
      const regex = /^\(?\d{3}\)?[- ]?\d{3}[- ]?\d{4}$/;
      allSame = false;
      submitBtn.prop("disabled",!(regex.test($(this).val().toString())));
    } else if ($(this).prop("type") == "select") {
    //Handle text or number inputs
    } else if (($(this).val().toString().length > 0 || $(this).attr("current_value").toString().length > 0) && ($(this).val().toString() != $(this).attr("current_value").toString())) {
      submitBtn.prop("disabled",false);
      allSame = false;
      return false;
    };
  });
  if(allSame) submitBtn.prop("disabled", true);
});

$(document).on("change","#upload_camp_photo", (event: { target: HTMLInputElement; }) => {
  let selectedFiles:FileList = (event.target as HTMLInputElement).files as FileList;
  let newPhotos:Array<File> = Array.from(selectedFiles);
  const MAX_FILE_SIZE_BYTES = 30 * 1024 * 1024;

  if (newPhotos.length > 0) {
		$("#addedImages").html('');
    let fileNames:Array<string> = [];
    for (let i:number = 0; i < newPhotos.length; i++) {
      if (newPhotos[i].size > MAX_FILE_SIZE_BYTES) {
        alert('File size exceeds 30MB. Please choose a smaller file.');
        $(this).val('');
        return;
      }
      const reader = new FileReader();
      reader.onload = function(e) {
        if (e.target?.result) {
          const img = $('<img>').attr('src',e.target.result as string);
          $("#addedImages").append(img);
        }
      };

      reader.readAsDataURL(newPhotos[i]);
      fileNames.push(newPhotos[i].name);
    }
    $("#imgFileName").text(fileNames.join(', '));
    $("#confirmUpload").prop("disabled",false);
  } else {
    $("#imgFileName").text("No file selected");
    $("#confirmUpload").prop("disabled",true);
  }
});

$("#confirmUpload").on("click",function () {
  const fileInput = $('#upload_camp_photo')[0] as HTMLInputElement;
  const selectedFiles = fileInput.files;

  const confBtn = $(this);
  confBtn.prop("disabled",true);

  //get campID from ?campID={campID} in url with urlParams.get("campID");
  let campID:string = new URLSearchParams(window.location.search).get("campID")?.toString();
  if(campID == null){
    campID = undefined;
    const campName = $("#camp_name").val().toString();
    uploadCampPhotos(selectedFiles,campID,campName).then((response) => {
      //reset modal
      $("#addedImages").html('');
      $("#upload_camp_photo").val('');
      $("#imgFileName").text("No file selected");
      $("#confirmUpload").prop("disabled",true);

      $("#campReportAddImageModal").modal("hide");
      //$("#campReportThanks").modal("show");
    }).catch((e) => {
      const err = new Error(JSON.stringify(e));$("#exception_str").val(err.name + ";" + err.message + ";" + err.stack);
      $("#errorModal").modal("show");
      confBtn.prop("disabled", false);
    });
  }else{
    //let campID:string = $('#upload_camp_photo').attr("campID")?.toString();
    uploadCampPhotos(selectedFiles,campID,undefined).then((response) => {
      //reset modal
      $("#addedImages").html('');
      $("#upload_camp_photo").val('');
      $("#imgFileName").text("No file selected");
      $("#confirmUpload").prop("disabled",true);

      $("#campReportAddImageModal").modal("hide");
      //$("#campReportThanks").modal("show");
    }).catch((e) => {
      confBtn.prop("disabled", false);
      const err = new Error(JSON.stringify(e));$("#exception_str").val(err.name + ";" + err.message + ";" + err.stack);
      $("#errorModal").modal("show");
    });
  }
});

$("#campReportAddImageModal").on('hidden.bs.modal',function() {
  $("#upload_camp_photo").val('');
  $("#addedImages").html('');
  $("#imgFileName").text("No file selected");
  $("#confirmUpload").prop("disabled",true);
});